// Written in this round about way for babel-transform-imports
import StaticRouter from "react-router/es/StaticRouter";

export default StaticRouter;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-router-dom/es/StaticRouter.js
// module id = 311
// module chunks = 0